import { useEffect } from 'react';
import Page from 'shared/types/Page'
import getCurrentPage from 'shared/utils/getCurrentPage'
import hasAnyRole from 'shared/utils/hasAnyRole'

interface useInitProps {
  setSubMenuPages: Function
  curLink: string
  curLoc: any
  pages?: Page[]
  label: string
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    getCurrentPage(props.curLoc).then((curPage) => {
      if (props.pages) {
        let subPages: Page[] = []
        props.pages.map((page) => {
          if (
            page.dropdownName === props.label &&
            (page.roles === undefined || hasAnyRole(page.roles))
          ) {
            subPages.push(page)
          }
        })
        props.setSubMenuPages(subPages)
      }
    })
  }, [])
}

export default useInit